import {
  COLORS,
  COMMON_STYLES,
  LazyImage,
  SUBHEADING_STYLES,
  TYPOGRAPHY,
  VARIANTS_STYLES,
} from "@dehaat/dds";
import React from "react";
import {
  Modal,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import BackCaret from "./icons/BackCaret";
import NutrientSummary from "./NutrientSummary";
import { DIMENSION_WIDTH } from "app/utils/common";
import { useTranslation } from "react-i18next";

const MicroNutrientModal = ({
  visible,
  onClose,
  data,
  title = "",
  imageUrl = "",
  subTitle = "",
  crop = "",
  district = "",
}: {
  visible: boolean;
  onClose: () => void;
  data: any;
  title?: string;
  imageUrl?: string;
  subTitle?: string;
  crop?: string;
  district?: string;
}) => {
  const isTab = DIMENSION_WIDTH > 425;
  const { t } = useTranslation();
  return (
    <Modal visible={visible} animationType="slide">
      <View style={styles.container}>
        <View
          style={[
            COMMON_STYLES.row,
            COMMON_STYLES.p1,
            COMMON_STYLES.divider,
            COMMON_STYLES.alignItemsCenter,
          ]}
        >
          <TouchableOpacity onPress={onClose}>
            <BackCaret height={25} width={25} />
          </TouchableOpacity>
          <View style={[COMMON_STYLES["ml0.5"]]}>
            <Text
              style={[SUBHEADING_STYLES.MEDIUM_S3, { color: COLORS.neutral90 }]}
            >
              {title}
            </Text>
            <Text style={[TYPOGRAPHY.CAPTION1, { color: COLORS.neutral70 }]}>
              {subTitle}
            </Text>
          </View>
        </View>

        <ScrollView
          style={[
            COMMON_STYLES.p1,
            { maxWidth: 600, margin: "auto", width: "100%" },
          ]}
        >
          <LazyImage
            imageUrl={imageUrl}
            imgStyles={[isTab ? styles.bannerImgDesktop : styles.bannerImg]}
            isResizeMethod
          />
          <View
            style={[
              COMMON_STYLES.row,
              COMMON_STYLES.justifyBetween,
              COMMON_STYLES["pv1/2"],
            ]}
          >
            <Text style={[VARIANTS_STYLES.MEDIUM]}>
              {t("nutrients_of_soil_in", { location: district })}
            </Text>{" "}
            <Text style={[VARIANTS_STYLES.MEDIUM]}>{crop}</Text>
          </View>
          <NutrientSummary data={data} />
        </ScrollView>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: COLORS.white,
  },
  sub: {
    fontSize: 14,
    color: COLORS.neutral90,
    marginBottom: 8,
  },
  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderColor: COLORS.neutral20,
    alignItems: "center",
  },
  label: {
    fontSize: 14,
    color: COLORS.neutral100,
    flex: 1,
  },
  icon: {
    fontSize: 18,
    marginHorizontal: 8,
  },
  temp: {
    fontSize: 14,
    color: COLORS.neutral100,
  },
  noteBox: {
    backgroundColor: COLORS.neutral20,
    padding: 12,
    marginVertical: 12,
    borderRadius: 8,
  },
  bannerImg: {
    width: "100%",
    height: 220,
    maxWidth: 600,
    borderRadius: 10,
    margin: "auto",
    marginBottom: 16,
    resizeMode: "contain",
  },
  bannerImgDesktop: {
    width: "100%",
    height: 350,
    maxWidth: 600,
    borderRadius: 16,
    margin: "auto",
    resizeMode: "contain",
  },
});

export default MicroNutrientModal;
